








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { adminInvoiceItemTableColumns } from '@/modules/invoice-item/models/columns/admin-invoice-item-table.column'
import { InvoiceItemResourceModel } from '@/modules/invoice-item/models/invoice-item-resource.model'
import AdminInvoiceItemTableRow from '@/modules/invoice-item/components/admin/table/AdminInvoiceItemTableRow.vue'

@Component({
  components: {
    TesTable
  }
})
export default class AdminInvoiceItemTable extends Vue {

  @ProvideReactive()
  @Prop({ required: true, default: () => [] }) invoiceItems!: InvoiceItemResourceModel[]
  private columns = adminInvoiceItemTableColumns()
  private rowComponent = AdminInvoiceItemTableRow
}
